// extracted by css-extract-rspack-plugin
export default {"row":"Report__row--mN5Zd","actions":"Report__actions--LWMEq","rightActions":"Report__rightActions--T04Gb"};